import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

export enum SignIconVariant {
  LOGIN = 'login',
  LOGOUT = 'logout',
}

interface ISignIconProps extends IConDefaultType {
  variant?: SignIconVariant;
}

function SignIcon({ color, className, size = 24, rotate, flip, variant = SignIconVariant.LOGIN }: ISignIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === SignIconVariant.LOGOUT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5355 3.46447C14.4732 4.40215 15 5.67392 15 7L15 8C15 8.55228 14.5523 9 14 9C13.4477 9 13 8.55228 13 8L13 7C13 6.20435 12.6839 5.44129 12.1213 4.87868C11.5587 4.31607 10.7956 4 10 4L7 4C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7L4 17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20L10 20C10.7956 20 11.5587 19.6839 12.1213 19.1213C12.6839 18.5587 13 17.7956 13 17L13 16C13 15.4477 13.4477 15 14 15C14.5523 15 15 15.4477 15 16L15 17C15 18.3261 14.4732 19.5979 13.5355 20.5355C12.5979 21.4732 11.3261 22 10 22L7 22C5.67392 22 4.40215 21.4732 3.46447 20.5355C2.52679 19.5979 2 18.3261 2 17L2 7C2 5.67392 2.52678 4.40215 3.46447 3.46447C4.40215 2.52678 5.67392 2 7 2L10 2C11.3261 2 12.5979 2.52678 13.5355 3.46447Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 12C22 12.5523 21.5523 13 21 13L8 13C7.44771 13 7 12.5523 7 12C7 11.4477 7.44771 11 8 11L21 11C21.5523 11 22 11.4477 22 12Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.7071 11.2929C22.0976 11.6834 22.0976 12.3166 21.7071 12.7071L18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071C16.9024 15.3166 16.9024 14.6834 17.2929 14.2929L19.5858 12L17.2929 9.70711C16.9024 9.31658 16.9024 8.68342 17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289L21.7071 11.2929Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === SignIconVariant.LOGIN && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4645 20.5355C9.52678 19.5979 9 18.3261 9 17L9 16C9 15.4477 9.44771 15 10 15C10.5523 15 11 15.4477 11 16L11 17C11 17.7956 11.3161 18.5587 11.8787 19.1213C12.4413 19.6839 13.2044 20 14 20L17 20C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17L20 7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4L14 4C13.2044 4 12.4413 4.31607 11.8787 4.87868C11.3161 5.44129 11 6.20435 11 7L11 8C11 8.55229 10.5523 9 10 9C9.44771 9 9 8.55229 9 8L9 7C9 5.67392 9.52678 4.40215 10.4645 3.46447C11.4021 2.52678 12.6739 2 14 2L17 2C18.3261 2 19.5979 2.52678 20.5355 3.46447C21.4732 4.40215 22 5.67392 22 7L22 17C22 18.3261 21.4732 19.5979 20.5355 20.5355C19.5979 21.4732 18.3261 22 17 22L14 22C12.6739 22 11.4021 21.4732 10.4645 20.5355Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 12C2 11.4477 2.44772 11 3 11L16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13L3 13C2.44772 13 2 12.5523 2 12Z"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2929 15.7071C11.9024 15.3166 11.9024 14.6834 12.2929 14.2929L14.5858 12L12.2929 9.70711C11.9024 9.31658 11.9024 8.68342 12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L13.7071 15.7071C13.3166 16.0976 12.6834 16.0976 12.2929 15.7071Z"
            fill={fill}
          />
        </svg>
      )}
    </i>
  );
}

export default SignIcon;
